module.exports = "pegasus_template/assets/web_template/hamburger.png";